<template>
  <div
    class="container-fluid  border-0 mb-0 shadow-none projectGantt"
  >
    <portal to="sidebar">    
        <finance :show="showFinance" @outSideClicked="showFinance = false" :fullWidth="false" :project="project" @paymentSuccess="_onPaymentSuccess"/>
        <approval :show="showApproval" @outSideClicked="showApproval = false" :fullWidth="false" :project="project" @approveSuccess="$emit('approveSuccess')"/>
    </portal>


    <div class="row no-gutters border row--overflow preview-box">
      <div
        :class="{ 'pt-3': editMode }"
        class="bg-white col-md-12 col-sm-12 border-right col-mod"
      >
        <div class="table-responsive table-responsive--mod">
          <table v-if="!isMobile" class="table align-items-center table-flush">
            <thead class="thead-light">
              <tr>
                <th scope="col" style="width:300px; height:27px;" class="py-0">
                  Task
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody class="list overflow-auto" v-if="openTasks">
              <tr
                v-for="(task, ind) in openTasks"
                :key="ind"
                @click="selectedTask = task"
                :class="{ active: true }"
                class="editable"
              >
                <td scope="row">
                  <div class="media-body py-2">
                    <strong>{{ task.name }}</strong>
                  </div>
                </td>

                <td scope="row">
                  <div class="media-body py-2">
                    <div class="media-body py-2">
                     {{ getPreviewQuotedText(task) || 'No Description' }}
                    </div>
                    <table class="table align-items-center table-flush border-0">
                      <thead>
                        <th scope="col" class="py-0">
                        Rate
                      </th>

                      <th scope="col" class="py-0">
                        Hours
                      </th>
                      <th scope="col" class="py-0">
                        Discount %
                      </th>
                      <th scope="col" class="py-0">
                        Month
                      </th>

                      <!-- <th scope="col" style="width:100px; height:27px;" class="py-0">
                  Action
                </th> -->
                      <th
                        scope="col"
                        style="padding-right:10px; height:27px;"
                        class="py-0"
                      >
                        <div class="media-body text-right">Total</div>
                      </th>
                      </thead>
                      <tbody>
                        <tr>
                          <td scope="row">
                            <div class="media-body">
                              <span
                                >{{
                                  profile.currency && profile.currency.symbol
                                }}
                                {{ task.hourly_cost }}</span
                              >
                            </div>
                          </td>

                          <td scope="row">
                            <div class="media-body">
                              <span>{{ task.quoted_hours }}</span>
                            </div>
                          </td>
                          <td scope="row">
                            <div class="media-body">
                              <span>{{ task.discount_percentage }}</span>
                            </div>
                          </td>
                          <td scope="row">
                            <div class="media-body">
                              <span>{{ task.no_of_days }}</span>
                            </div>
                          </td>

                          <td scope="row">
                            <div class="media-body text-right total-price pr-2">
                              <h2>{{ getTotalCost(task) }}</h2>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
         
          

       
          <div class="d-flex justify-content-end">
            <div class="col-md-4">
              <div class="" show-footer-line="true">
                <!---->
                <div class="card-body pr-0">
                  <div class="row">
                    <div class="col text-center" v-if="false">
                      <h5 class="card-title text-uppercase text-muted mb-0">
                        Payment
                      </h5>
                      <span v-if="project && project.payment_status == 'SUCCESS'" class="h5 font-weight-bold mb-0 text-success"
                        ><i class="fa fa-check-circle" aria-hidden="true"></i> SUCCESS</span
                      >
                      <span v-if="project && project.payment_status == 'PENDING'" class="h5 font-weight-bold mb-0 text-primary"
                        ><i class="fa fa-user-plus" aria-hidden="true"></i> PENDING</span
                      >

                      <span v-if="project && project.payment_status == 'PAYER_REQUESTED'" class="h5 font-weight-bold mb-0 text-primary"
                        ><i class="fa fa-user-plus" aria-hidden="true"></i> REQUESTED</span
                      >

                      <span v-if="project && project.payment_status == 'FAILED'" class="h5 font-weight-bold mb-0 text-danger"
                        ><i class="fa fa-times-circle" aria-hidden="true"></i> FAILED</span
                      >
                    </div>

                    <div class="col text-center" v-if="false">
                      <h5 class="card-title text-uppercase text-muted mb-0">
                        Approval
                      </h5>
                      <span v-if="project && project.approval_status == 'APPROVED'" class="h5 font-weight-bold mb-0 text-success"
                        ><i class="fa fa-check-circle" aria-hidden="true"></i> APPROVED</span
                      >
                      <span v-if="project && (project.approval_status == 'QUOTED')" class="h5 font-weight-bold mb-0 text-primary"
                        ><i class="fa fa-times-circle" aria-hidden="true"></i>QUOTED</span
                      >

                      <span v-if="project && project.approval_status == 'REJECTED'" class="h5 font-weight-bold mb-0 text-danger"
                        ><i class="fa fa-times-circle" aria-hidden="true"></i> REJECTED</span
                      >

                      <span v-if="project && project.approval_status == 'APPROVAL_REQUESTED'" class="h5 font-weight-bold mb-0 text-primary"
                        ><i class="fa fa-user-plus" aria-hidden="true"></i> REQUESTED</span
                      >
                    </div>


                    <div class="col text-right">
                      <h5 class="card-title text-uppercase text-muted mb-0">
                        Total Cost
                      </h5>
                      <span class="h2 font-weight-bold mb-0"
                        >{{ projectBudget.currency }}
                        {{ projectBudget.cost }}</span
                      >
                    </div>

                    <!-- <div class="col text-center">
                      <h5 class="card-title text-uppercase text-muted mb-0">
                        Total Hours
                      </h5>
                      <span class="h2 font-weight-bold mb-0">{{projectBudget.hours}}</span>
                    </div> -->
                  </div>
                </div>
                <!----><!---->
              </div>
            </div>

          </div>


          <div class="d-flex justify-content-end p-2 mb-2" v-if="false">
            
            <base-button
                    v-if="project.payment_status == 'SUCCESS' && project.approval_status != 'APPROVED' && project.user_owner && (project.user_owner.user.id == profile.id)"
                    size="sm"
                    @click="_onRequestApprovalClicked"
                    type="danger"
                  >Request Approval</base-button>

                <base-button
                    v-if="project.payment_status != 'SUCCESS' && project.user_owner && (project.user_owner.user.id == profile.id)"
                    size="sm"
                    @click="_onPaymentClicked"
                    type="danger"
                  >Request Approval</base-button>

                  <div v-if="project.payment_status != 'SUCCESS' && project.financePayer && (project.financePayer.user.id == profile.id)">
                      
                      <base-button
                        size="sm"
                        @click="_onPaymentClicked"
                        type="success"
                      >Proceed Payment</base-button>
                  </div>

                  <div v-if="project.payment_status == 'SUCCESS' && project.approver && (project.approver.user.id == profile.id)">
                      <base-button
                        size="sm"
                        @click="_onAcceptClicked"
                        type="success"
                      >Accept & Approve this Project</base-button>

                    <el-popover
                      title="Rejection Note"
                      placement="bottom"
                      width="400"
                    >

                      <div class="d-flex flex-column justify-content-end align-items-end">
                        <html-editor v-model="project.reject_reason" class="w-100"/>   

                        <base-button
                          size="sm"
                          
                          @click="_onRejectClicked"
                          type="primary"
                        >Submit</base-button>
                    </div>

                     <base-button
                          size="sm"
                          type="danger"
                          slot="reference"
                        >Reject Approval</base-button>
                   
                     
                    </el-popover>
                      

                  </div>

                  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import HtmlEditor from "../../components/Inputs/HtmlEditor.vue";
import AssetThread from "./AssetThread.vue";
import { isMobile } from "mobile-device-detect";
import Finance from './Finance.vue';
import Approval from './Approval.vue';
import swal from "sweetalert2";
export default {
  props: ["tasks", "project"],
  components: { AssetThread, HtmlEditor, Finance, Approval, HtmlEditor },
  name: "TableViewPreview",
  data() {
    return {
      selectedTask: this.tasks.data[0] || null,
      isMobile: isMobile,
      editMode: false,
      showFinance: false,
      showApproval: false,
      
    };
  },
  computed: {
    ...mapState("user", ["profile"]),
    openTasks() {
      return (
        (this.tasks && this.tasks.data.filter(t => t.status != "CLOSED")) || []
      );
    },
    closedTasks() {
      return (
        (this.tasks && this.tasks.data.filter(t => t.status == "CLOSED")) || []
      );
    },
    projectBudget() {
      let totalHours = 0
      let totalCost = 0
      let tasks = (this.tasks && this.tasks.data) || []
      
      tasks.map(t => {
          let tc = parseFloat((t.hourly_cost || 0) * (t.quoted_hours || 0));
          totalHours = parseInt(t.quoted_hours || 0);
          let dp = isNaN(parseInt(t.discount_percentage))
            ? 0
            : parseInt(t.discount_percentage);
          dp= 0; //for now make all discount 0 as i dont see this in new design
         const numOfDays = parseInt(t.no_of_days || 1);
          const teamSize = parseInt(t.total_team_members || 1);
         //totalCost += (tc - (tc * dp) / 100);
          totalCost += tc;
          //totalCost = totalCost.toFixed(2);
          console.log(dp, t.no_of_days, "project budget")
        })

      if (totalCost >= 1000) {
        totalCost = (totalCost / 1000).toFixed(2) + "k";
      } else {
        totalCost = (totalCost).toFixed(2);
      }
          
      return {currency: this.profile && this.profile.currency.symbol, cost:totalCost, hours: totalHours}
    }
  },
  mounted() {

  },

  methods: {
    ...mapActions("task", ["updateTask"]),
    ...mapActions("project", ["changeApprovalStatus"]),
    ...mapMutations(["setGanttRender", "setLoading"]),

    _onPaymentClicked () {
      this.showFinance = true
      this.showApproval = false
    },

    _onRequestApprovalClicked () {
      this.showApproval = true
      this.showFinance = false
    },

    async _onRejectClicked () {
      swal({
        title: "Are you sure to reject?",
        text: `Please click Reject to proceed!`,
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Reject!",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            let res = await this.changeApprovalStatus({
              id: this.project.id,
              approval_status: 'REJECTED',
              reject_reason: this.project.reject_reason
            })

            this.$snack.success("Rejected Successfully")
            this.$emit('approveSuccess')

          } catch(e) {
            console.log(e)
            this.$snack.success("Error rejecting approval request")
          }
        }
      });
      
    },

    async _onAcceptClicked () {
      try {
        let res = await this.changeApprovalStatus({
          id: this.project.id,
          approval_status: 'APPROVED'
        })

         this.$snack.success("Accepted Successfully")
         this.$emit('approveSuccess')

      } catch(e) {
        console.log(e)
        this.$snack.success("Error accepting approval request")
      }
    },

    _onPaymentSuccess () {
      //if owner, show approval request screen
      if(this.project && this.project.user_owner.user.id == this.profile.id) {
        this.showApproval = true
        this.showFinance = false
      }
      

      this.$emit('paymentSuccess')
    },

  
    getPreviewQuotedText(task) {
      return task.quoted_text && task.quoted_text.replace(/<[^>]*>?/gm, "");
    },

    getTotalCost(task) {
      let totalHours = 0;
      let totalCost = 0;
      let t = task || {};

      totalCost = parseFloat((t.hourly_cost || 0) * (t.quoted_hours || 0));
      totalHours = parseInt(t.quoted_hours || 0);
      const dp = isNaN(parseInt(t.discount_percentage))
        ? 0
        : parseInt(t.discount_percentage);
      const numOfDays = parseInt(t.no_of_days || 1);
      //totalCost = (totalCost - (totalCost * dp) / 100) * numOfDays;
      totalCost = totalCost.toFixed(2);
      if (totalCost >= 1000) {
        totalCost = (totalCost / 1000).toFixed(2) + "k";
      }

      return (this.profile && this.profile.currency.symbol) + totalCost;
    },

    
  }
};
</script>

<style lang="css" scoped>
.select-small.el-select .el-input .el-input__inner {
  height: 31px;
}
.table td {
  padding: 0.3rem;
} 
</style>

<style lang="scss" scoped>
.sm-gantt_task_line {
  height: 31px !important;
  line-height: 31px !important;
  .gantt_task_content {
    font-size: 13px;
    line-height: 31px;
  }
}
.media-body {
  padding-left: 1rem;
  white-space: normal;
  .btn-sm {
    padding: 0.344rem 0.5rem !important;
  }
}
.total-price {
  h2 {
    font-size: 0.875rem !important;
    margin-bottom: 0;
  }
}
.close-btn-wrap {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-right: 25px;
  button {
    background: transparent;
    border: 0;
    padding: 0;
    i {
      color: #2dce89;
    }
    &:hover {
      opacity: 0.5;
    }
  }
}
.mobile-view-table {
  margin-bottom: 0;
  border-bottom: 1px solid #e9ecef;
  tbody.list {
    tr {
      th.project {
        white-space: pre-wrap;
      }
      td.edit {
        width: 40px;
      }
    }
  }
}
.ul-tasks-edit {
  padding: 15px;
  padding-bottom: 0;
  li {
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    &.wrap {
      input {
        height: calc(0.45em + 1.25rem + 17px);
      }
      li {
        flex: 0 0 50%;
        max-width: 50%;
        &:first-child {
          padding-right: 5px;
        }
        &:last-child {
          padding-left: 5px;
        }
      }
    }
    label {
      font-weight: 500;
      margin-bottom: 2px;
    }
  }
}
@media only screen and (max-width: 768px) {
  .ul-tasks-edit {
    li.wrap {
      input {
        height: calc(0.45em + 1.25rem + 16px);
      }
    }
  }
}
.preview-box {
  margin-top: 10px;
}
</style>
